export class DropProductConfig {
    public static levels = {
        '2': {
            products: [
                {
                    i: 0,
                    j: 3,
                },
                {
                    i: 3,
                    j: 3,
                },
                {
                    i: 6,
                    j: 3,
                }
            ]
        }
    }
}